<template>
  <v-btn fab v-bind="buttonProps" v-on="$listeners">
    <v-icon :color="iconColor" class="material-icons-outlined">
      {{ icon }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'IconButton',
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: 'small',
    },
    color: {
      type: String,
      default: 'grey lighten-2',
    },
    elevation: {
      type: Number,
      default: 0,
    },
    iconColor: {
      type: String,
      default: 'grey darken-2',
    },
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    buttonProps() {
      const props = {
        ...this.$attrs,
        color: this.color,
        elevation: this.elevation,
      };
      if (this.size) {
        props[this.size] = true;
      }
      return props;
    },
  },
};
</script>
